/**
 * Povratna putanja nakon prijave ili registracije (`?returnUrl=`). Dopuštena je samo relativna
 * putanja unutar aplikacije — sve ostalo (`https://…`, `//drugi.hr`, `/\drugi.hr`, `javascript:`)
 * vraća `null`, da prijava ne postane otvoreno preusmjeravanje.
 */
export function sigurnaPovratnaPutanja(url: string | null | undefined): string | null {
  if (typeof url !== 'string') return null;
  const u = url.trim();
  if (!u.startsWith('/') || u.startsWith('//') || u.includes('\\')) return null;
  // Kontrolni znakovi (tab, novi red) preglednik zna izbaciti pa od „/\t/x” napraviti „//x”.
  if ([...u].some(c => c.charCodeAt(0) < 0x20 || c.charCodeAt(0) === 0x7f)) return null;
  // Povratak na prijavu ili registraciju bi zavrtio krug.
  if (/^\/(login|registracija)(\/|\?|#|$)/.test(u)) return null;
  return u;
}
